export const iconFontAwesomeArrowsArrowUpZA = (
	<i className="fa-solid fa-arrow-up-z-a"></i>
);
